import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../redux/actions';

export function useBankAccounts({ autoSelectFirst = false } = {}) {
  const dispatch = useDispatch();
  const [bankAccounts, setBankAccounts] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const reload = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const rows = await dispatch(actions.listBankAccounts());
      setBankAccounts(rows);
      if (autoSelectFirst && rows.length > 0) {
        setSelectedId((current) => current || rows[0].id);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [dispatch, autoSelectFirst]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { bankAccounts, selectedId, setSelectedId, loading, error, reload };
}

export default useBankAccounts;
